import BaseViewController from "../base-view-controller";
import {
  valueIsNumber,
  valueInRanage,
  setWarning,
  removeWarning
} from "../../utils/blood-sugar-helpers";

class LowBloodSugarThresholdViewController extends BaseViewController {
  preprocessScreenData() {
    super.preprocessScreenData();

    const { fields, footerFields } = this.screen;

    const labelField = document.getElementById("low_blood_sugar-label");
    const inputField = document.getElementById("low_blood_sugar-input");

    const bloodSugar = this.appData.values.low_blood_sugar;
    const bloodSugarValue = Number(bloodSugar);
    const MinThreshold = Number(this.appData.values.min_blood_sugar_threshold);
    const MaxThreshold = Number(this.appData.values.max_blood_sugar_threshold);
    const warningMessage = fields.find(f => f.name === "web_warning_message");

    if (labelField === null || inputField === null || bloodSugar === null) {
      return null;
    }

    if (
      valueIsNumber(bloodSugar) &&
      valueInRanage(bloodSugarValue, MinThreshold, MaxThreshold)
    ) {
      removeWarning(labelField, inputField, footerFields[0], warningMessage);
    } else {
      setWarning(labelField, inputField, footerFields[0], warningMessage);
    }
  }
}

export default LowBloodSugarThresholdViewController;
